function t(r) {
  return typeof r == "string" && Number.isNaN(Number(r)) ? r : `${r}px`;
}
export {
  t as c
};
